<template>
  <outro-template status="success" :hide-content="true" :show-exit-button="true" :memo="{ label: 'Les absences', link: 'files/memo2_absences.pdf' }">
    <template v-slot:title>
      Déclarer une absence
    </template>
  </outro-template>
</template>

<script>
import OutroTemplate from '@shared/components/OutroTemplate'

export default {
  name: 'EndOutro',
  components: {
    OutroTemplate
  }
}
</script>

<style lang="scss">

</style>
